<template>
  <div class="map">
    <div class="map__item">
      <gmap-map
          ref="gmap"
          :center="center"
          :zoom="9"
          style="width:100%;  height: 100%;"
      >
        <GmapCustomMarker
            v-for="(m, index) in markers"
            :marker="m.position"
            :key="index"
            @click.native="toggleInfoWindow(m, index)"
            @mouseenter="() => markerHover(m, index)"
            :z-index="m.zIndex || 50"
            :offsetX="0"
            :offsetY="15"
        >
          <div class="marker" @mouseenter="markerEnter(m)" @mouseleave="markerLeave(m)" :style="`background-color: ${m.color}`">
            <div class="marker__preview">
              {{ m.patient }}
            </div>
            {{ m.patient.split(' ')[0][0] }}{{ m.patient.split(' ')[1][0] }}
          </div>
        </GmapCustomMarker>

        <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen=false"
        >
          <div v-html="infoContent"></div>
        </gmap-info-window>
      </gmap-map>
    </div>
  </div>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker';

export default {
  props: ['therapistId', 'therapists'],
  components: {
    GmapCustomMarker
  },
  data() {
    return {
      selectedTherapist: [],
      therapist: null,
      center: { lat: 34.003985, lng: -118.109497 },
      map: null,
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -40
        }
      },
      markers: [],
    }
  },
  watch: {
    therapistId() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      const therapist = this.therapists.find(t => t.id === marker.tid);
      marker.therapist = therapist;
      this.infoContent = this.getInfoWindowContent(marker);
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    markerLeave(marker) {
      this.markers = this.markers.map(item => {
        if (item.id === marker.id) {
          item.zIndex = 50;
        }
        return item;
      })
    },
    markerEnter(marker) {
      this.markers = this.markers.map(item => {
        if (item.id === marker.id) {
          item.zIndex = 999;
        }
        return item;
      })
    },
    getInfoWindowContent: function (marker) {
      return (`
         <div class="info-window">
          <div class="info-window__item">
            <div class="info-window__title">
              Patient
            </div>
            <div class="info-window__value">
               ${marker.patient}
            </div>
          </div>
          <div class="info-window__item">
            <div class="info-window__title">
              Case Description
            </div>
            <div class="info-window__value">
               ${marker.case}
            </div>
          </div>
          <div class="info-window__item">
            <div class="info-window__title">
              Address
            </div>
            <div class="info-window__value">
              ${marker.address}
            </div>
          </div>
          <div class="info-window__item">
          <div class="info-window__flex">
          <div>
           <div class="info-window__title">
              Last Visit
            </div>
            <div class="info-window__value">
              ${marker.last_visit}
            </div>
          </div>
          <div>
           <div class="info-window__title">
              Next Visit
            </div>
            <div class="info-window__value">
              ${marker.next_visit}
            </div>
          </div>
          </div>
          </div>
        </div>
        `);
    },
    async getData() {
      this.infoWinOpen = false;
      const params = {'tid' : this.therapistId.toString()};
      try {
        const res = await this.axios.get('/api/locations', { params });
        this.markers = res.map((item, index) => {
          item.id = index;
          item.position = { lng: +item.lon, lat: +item.lat };
          return item;
        });
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .map {
    padding: 30px 0 100px;
    &__item {
      height: 700px;
      background-color: #fff;
    }
  }

  .marker {
    width: 38px;
    height: 38px;
    box-shadow: 0 5px 10px rgba(51, 51, 51, 0.51);
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00234e;
    font-size: 16px;
    text-transform: uppercase;
    font-family: 'Montserrat', sans-serif;
    border-radius: 50%;
    font-weight: 600;
    position: relative;
    z-index: 999999;
    &:hover {
      .marker__preview {
        transition-delay: .2s;
        opacity: 1;
      }
    }
    &__preview {
      box-shadow: 0 5px 10px rgba(0, 35, 78, 0.24);
      background-color: #ffffff;
      border-radius: 5px;
      padding: 10px 15px;
      color: #1c1f24;
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50px);
      transition: .3s;
      opacity: 0;
      pointer-events: none;
      &:before {
        content: "";
        position: absolute;
        border: 10px solid transparent; border-top: 10px solid #fff;
        left: 50%;
        transform: translateX(-50%);
        bottom: -17px;
      }
    }
  }
</style>

<style lang="scss">
  .info-window {
    width: 250px;
    background-color: #ffffff;
    &__item {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    &__title {
      font-size: 12px;
      font-weight: 500;
      opacity: 0.8;
      color: #5f748f;
      margin-bottom: 5px;
    }
    &__value {
      color: #1c1f24;
      font-size: 12px;
      font-weight: 500;
    }
    &__flex {
      display: flex;
      justify-content: space-between;
      &>div {
        width: 50%;
      }
    }
  }
</style>
